<sb-tabs [isTop]="true" [tabs]="currentPageTabs$ | async"></sb-tabs>
